import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import dateReducer from './slices/dateSlice';
import { apiSlice } from './slices/apiSlice';
import dashboardReducer from './slices/dashboardSlice';
import runpnlReducer from './slices/runpnlSlice';
import dailypnlReducer from './slices/dailypnlSlice';
import dailyjournalReducer from './slices/dailyjournalSlice';
import tradelogsReducer from './slices/tradelogsSlice';
import darkmodeReducer from './slices/darkmodeSlice';
import smallcalendarReducer from './slices/smallcalendarSlice';
import reportReducer from './slices/reportSlice';
import subscriptionReducer from './slices/subscriptionSlice';
import courseReducer from './slices/courseSlice';
import usersReducer from './slices/usersSlice';
import paymentsReducer from './slices/paymentsSlice';
import chatReducer from './slices/chatSlice';
const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    date: dateReducer,
    dashboard: dashboardReducer,
    runpnl: runpnlReducer,
    dailypnl: dailypnlReducer,
    dailyjournal: dailyjournalReducer,
    tradelogs: tradelogsReducer,
    darkmode: darkmodeReducer,
    report: reportReducer,
    smallcalendar: smallcalendarReducer,
    subscription: subscriptionReducer,
    course: courseReducer,
    users: usersReducer,
    payments: paymentsReducer,
    chat:chatReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
});

export default store;
